//
//
//
//
//
//
//
//
//
//
//
//
//

import GpsMap from "@/0/components/comMap/comBaiduMap2.vue";
export default {
  components: {
    "gps-map": GpsMap
  },
  props: ["controlItem"],
  data() {
    return {
      // GpsType:'wgs84',
      // Lat: 0,
      // Lng: 0,      
      // GpsFullAddress: "",
    };
  },
  created() {},
  mounted() {
    //this.getLocation();
    return;
  },
  methods: {

    setControlValue(gpsValue){
      console.log("setControlValue--gpsValue",gpsValue);
      //var val = this.Lat+","+this.Lng+","+this.GpsType+","+this.GpsFullAddress;
      this.controlItem.ControlValue = gpsValue;
    },

    getLocation() {
      this.$refs.comGpsMap.getLocation();      
    },    
    
  }
};
